import { render, staticRenderFns } from "./proposal-presentation.vue?vue&type=template&id=4d681760"
import script from "./proposal-presentation.vue?vue&type=script&lang=js"
export * from "./proposal-presentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports